import Dexie, { type Table } from "dexie";
import type { ICacheEntry } from "./cache.types";

class CacheDatabase extends Dexie {
  entries!: Table<ICacheEntry, string>;

  constructor() {
    super("AfinaStatisticsCache");
    this.version(1).stores({
      entries: "key, namespace, updatedAt",
    });
  }
}

export const cacheDB = new CacheDatabase();
